import { useGetUserProfile } from '~/domains/users/queries'

export default defineNuxtRouteMiddleware(async () => {
  const localePath = useLocalePath()
  const { data: user, suspense } = useGetUserProfile()

  await suspense()

  if (!user.value) {
    return await navigateTo(localePath('/login'), {
      replace: true,
    })
  }

  if (user.value.role !== 'super_admin') {
    return abortNavigation(createError({
      statusCode: 403,
      statusMessage: 'Forbidden',
    }))
  }
})
